export * from './create-playlist/create-playlist.component';
export * from './edit-playlist/edit-playlist.component';
export * from './create-que-playlist/create-que-playlist.component';
export * from './playlist-detail/playlist-detail.component';
export * from './playlist-item/playlist-item.component';
export * from './playlists.component';



// WEBPACK FOOTER //
// ./src/app/playlists/index.ts